var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-widget",class:_vm.className},[_c('div',[_vm._t("default"),_c('v-sheet',{staticClass:"mt-1",attrs:{"color":"secondary","width":"100%","height":"3px"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }